import { Node } from "@tiptap/core";

export const InputRadio = Node.create({
  name: "inputRadio",
  group: "block",
  atom: true,
  selectable: true,

  parseHTML() {
    return [{ tag: 'input[type="radio"]' }];
  },

  renderHTML({ node }) {
    return [
      "input",
      {
        type: "radio",
        id: node.attrs.id,
        name: node.attrs.name,
        checked: node.attrs.checked ? "checked" : null,
      },
    ];
  },

  addAttributes() {
    return {
      id: { default: null },
      name: { default: null },
      checked: {
        default: false,
        parseHTML: (element) => element.hasAttribute("checked"),
        renderHTML: (attributes) => (attributes.checked ? { checked: "checked" } : {}),
      },
    };
  },
});


